import type { MutableRefObject } from 'react'
import { useCallback, useEffect, useRef, useState } from 'react'

// use 'control' for 'ctrl', 'shift', 'alternate'
export default function (
  targetKey: string
): [boolean, MutableRefObject<boolean>] {
  const [keyPressed, setKeyPressed] = useState(false)
  // State for keeping track of whether key is pressed
  const keyPressedRef = useRef<boolean>(false)
  // If pressed key is our target key then set to true
  const downHandler = useCallback(
    function ({ key }: KeyboardEvent): void {
      // eslint-disable-next-line no-console
      // console.log(`------ useKeyPress downHandler ${key} --------`)
      if (key.toLowerCase() === targetKey.toLowerCase()) {
        setKeyPressed(true)
        keyPressedRef.current = true
      }
    },
    [targetKey]
  )
  // If released key is our target key then set to false
  const upHandler = useCallback(
    function ({ key }: KeyboardEvent): void {
      // eslint-disable-next-line no-console
      // console.log(`------ useKeyPress upHandler ${key} --------`)
      if (key.toLowerCase() === targetKey.toLowerCase()) {
        setKeyPressed(false)
        keyPressedRef.current = false
      }
    },
    [targetKey]
  )
  // Add event listeners
  useEffect(() => {
    // eslint-disable-next-line no-console
    // console.log('------ add key press listener --------')
    window.addEventListener('keydown', downHandler)
    window.addEventListener('keyup', upHandler)
    // Remove event listeners on cleanup
    return () => {
      // eslint-disable-next-line no-console
      // console.log('------ remove key press listener --------')
      window.removeEventListener('keydown', downHandler)
      window.removeEventListener('keyup', upHandler)
    }
  }, [downHandler, upHandler])
  // eslint-disable-next-line no-console
  // console.log(`------ useKeyPress keyPressed ${keyPressed} --------`)
  return [keyPressed, keyPressedRef]
}
